/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import classNames from 'classnames';

import AlgoliaResultsCount from 'components/consumer/ProductListingPage/components/AlgoliaResultsCount';

const ProductSearchCount = ({ title, indexClick, selectedOption, id }) => {
  const isSelected = selectedOption === id;

  return (
    <div className="px-0 py-1.5 max-[767px]:p-0 hover:text-brand">
      <button
        type="button"
        className={classNames('w-full bg-white text-center lg:text-left', {
          'font-bold': isSelected,
        })}
        onClick={() => {
          indexClick(title.toLowerCase());
        }}
      >
        {title}
        <AlgoliaResultsCount prefix=" (" suffix=")" />
      </button>
    </div>
  );
};

export default ProductSearchCount;
